import { Component, OnInit } from '@angular/core';
import { RewardsSignupGQL } from './loyalty-register.graphql';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-loyalty-register',
  templateUrl: './loyalty-register.component.html',
  styleUrls: ['./loyalty-register.component.scss']
})
export class LoyaltyRegisterComponent implements OnInit {
  registerForm: UntypedFormGroup;
  hide: boolean = true;
  registerBtnloading: boolean = false;

  constructor(
    private rewardsSignupGQL: RewardsSignupGQL,
    fb: UntypedFormBuilder, 
    private toastr: ToastrService
    ) {
    this.registerForm = fb.group({
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      password: new UntypedFormControl(null, Validators.required),
      password_confirmation: new UntypedFormControl(null, Validators.required),
      first_name:new UntypedFormControl(null, Validators.required),
      last_name: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {}

  onRegisterSubmit() {
    this.registerBtnloading = true;
    this.rewardsSignupGQL
    .mutate({
      ...this.registerForm.value
    }).subscribe(({data}) => {
      if (data.registration.success) {
        this.toastr.success('You have been successfully registered!', null);
      }
      this.registerBtnloading = false;
    }, err => {
        this.toastr.error(err.message, null, {
          timeOut: 5000,
        });
        this.registerBtnloading = false;
    });
  }
}
